import Navbar from "./components/navbar";
import Carousel from './components/react-bootstrap/Carousel';
import Card from './components/react-bootstrap/Card';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import 'react-big-calendar/lib/css/react-big-calendar.css'; // Import CSS here
import CalendarEvents from './CalendarEvents';
import { AuthProvider } from './AuthContext';
import PrivateRoute from './PrivateRoute'; // We'll define this next

function App() {
  
  return (
    <div>
      <Container>
        <Row className="header__section">
          <Navbar />
        </Row>
        <AuthProvider>
          <PrivateRoute>
            <CalendarEvents />
          </PrivateRoute>
        </AuthProvider>

        <div class="homepage_carousel row">
          <Carousel/>
        </div>
        <Row>
  
          <Card/>
        </Row>
      </Container>
    </div>
  );
}

export default App;